import { render, staticRenderFns } from "./ProductsForm.vue?vue&type=template&id=21b14db2&scoped=true&"
import script from "./ProductsForm.vue?vue&type=script&lang=js&"
export * from "./ProductsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductsForm.vue?vue&type=style&index=0&id=21b14db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b14db2",
  null
  
)

export default component.exports